import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { config } from "../../style";
import { get } from "../../api";
import RenderContent from "../../components/RenderContent";

const ContactList = [
    {
        id: "1",
        title: "Primary Event Manager",
        name: "Sarah Johnson",
        phone: "+1 (555) 123-4567",
        img: "/static/images/avatars/avatar_2.png",
    },
    {
        id: "2",
        title: "Secondary Event Manager",
        name: "Frances Townsend",
        phone: "(312) 283-5653",
        img: "/static/images/avatars/avatar_2.png",
    },
    {
        id: "3",
        title: "Sales Agent",
        name: "Emily Carter",
        phone: "+1 (555) 246-1357",
        img: "/static/images/avatars/avatar_2.png",
    },
];

const ContactNotes = [
    {
        id: "1",
        heading: "Preferred Contact Method:",
        para: "Nancy prefers email for detailed discussions and phone calls for urgent matters.",
    },
    {
        id: "2",
        heading: "Availability:",
        para: "Available Monday–Friday from 9 AM to 6 PM (CST). Limited availability on weekends.",
    },
    {
        id: "3",
        heading: "Time Zone Consideration:",
        para: "Based in Chicago (CST); adjust communication timing accordingly.",
    },
    {
        id: "4",
        heading: "Emergency Contact:",
        para: "In case of urgent issues, reach out via phone call or text message.",
    },
    {
        id: "5",
        heading: "Additional Notes:",
        para: "",
        list: [
            "Familiar with event logistics and can assist with last-minute changes.",
            "Has direct coordination with the venue and transport vendors.",
            "Can escalate issues to senior management if required.",
        ],
    },
];
function EventContacts({ data }) {
    const [eventContactData, setEventContactData] = React.useState([]);
    const [bookingAgentData, setBookingAgentData] = React.useState([]);
    const [leadData, setLeadData] = React.useState([]);
    useEffect(() => {
        const prepareData = async () => {
            let records = [];
            if (data?.primaryClientEMId) {
                records.push({ ...data.primaryClientEM, title: "Primary Event Manager" });
            }
            if (data?.secondaryClientEMId) {
                records.push({ ...data.secondaryClientEM, title: "Secondary Event Manager" });
            }
            if (data.dayOfEventEMId) {
                records.push({ ...data.dayOfEvent, title: "Day of Event Manager" });
            }
            setEventContactData(records);

            let bookingRecords = [];
            if (data.bookingAgentId) {
                bookingRecords.push({ ...data.bookingAgent, title: "Booking Agent" });
            }
            setBookingAgentData(bookingRecords);

            let leadRecords = [];
            if (data.associateLeadId) {
                leadRecords.push({ ...data.associateLead, title: "Associate Lead", displayOnlyEmail: true });
            }
            setLeadData(leadRecords);
        };

        prepareData();
    }, [data]);

    useEffect(() => {
        const prepareData = async () => {
            if (eventContactData.length > 0) {
                Promise.all(eventContactData.map((contact) => contactImage(contact.FullPhotoUrl))).then((urls) => {
                    let records = eventContactData.map((contact, index) => ({
                        ...contact,
                        imageURL: urls[index],
                    }));
                    setEventContactData(records);
                });
            }

            if (bookingAgentData.length > 0) {
                Promise.all(bookingAgentData.map((contact) => contactImage(contact.FullPhotoUrl))).then((urls) => {
                    let records = bookingAgentData.map((contact, index) => ({
                        ...contact,
                        imageURL: urls[index],
                    }));
                    setBookingAgentData(records);
                });
            }

            if (leadData.length > 0) {
                Promise.all(leadData.map((contact) => contactImage(contact.FullPhotoUrl))).then((urls) => {
                    let records = leadData.map((contact, index) => ({
                        ...contact,
                        imageURL: urls[index],
                    }));
                    setLeadData(records);
                });
            }
        };

        prepareData();
    }, [eventContactData]);

    const getContactList = () => {
        let records = [];
        if (data.primaryClientEMId) {
            records.push({ ...data.primaryClientEM, title: "Primary Event Manager" });
        }
        if (data.secondaryClientEMId) {
            records.push({ ...data.secondaryClientEM, title: "Secondary Event Manager" });
        }
        if (data.dayOfEventEMId) {
            records.push({ ...data.dayOfEvent, title: "Day of Event Manager" });
        }
        debugger;
        return records;
    };

    const contactImage = async (imageURL) => {
        if (imageURL) {
            let result = await get("opportunity/getUserImage", {
                url: encodeURIComponent(imageURL),
            });

            if (result.isSuccess) {
                return result.data;
            }
        }

        return null;
    };

    return (
        <div>
            <Grid container spacing={2}>
                {eventContactData.map((contact) => {
                    return (
                        <Grid item xs={12} sm={4}>
                            <Box>
                                <Typography component={"h5"} variant="paraText5" color={"gray.main"}>
                                    {contact.title}
                                </Typography>

                                <Box display={"flex"} alignItems={"start"} marginTop={"0.5rem"}>
                                    <Box component={"img"} src={contact.imageURL} alt="" borderRadius={"8px"} height={50} width={50} marginRight={"0.8rem"} marginTop={'4px'}></Box>
                                    <Box>
                                        <Typography component={"p"} variant="paraText3" color={"#101828"}>
                                            {contact.Name}
                                        </Typography>
                                        <Box display={"flex"} marginTop={"0.25rem"}>
                                            <MailOutlineIcon fontSize="small" sx={{ color: "brand.main" }} />
                                            <Typography component={"p"} variant="paraText6" color={"#475467"} marginLeft={"0.25rem"}>
                                                {contact.Email}
                                            </Typography>
                                        </Box>
                                        <Box display={"flex"} marginTop={"0.25rem"}>
                                            <PhoneOutlinedIcon fontSize="small" sx={{ color: "brand.main" }} />
                                            <Typography component={"p"} variant="paraText6" color={"#475467"} marginLeft={"0.25rem"}>
                                                {contact.Phone}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>

            {bookingAgentData?.length > 0 && (
                <>
                    <Divider sx={{ margin: "1.5rem -24px" }} />
                    <Grid container spacing={2}>
                        {bookingAgentData.map((contact) => {
                            return (
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <Typography component={"h5"} variant="paraText5" color={"gray.main"}>
                                            {contact.title}
                                        </Typography>

                                        <Box display={"flex"} alignItems={"start"} marginTop={"0.5rem"}>
                                            <Box component={"img"} src={contact.imageURL} alt="" borderRadius={"8px"} height={50} width={50} marginRight={"0.8rem"} marginTop={'4px'}></Box>
                                            <Box>
                                                <Typography component={"p"} variant="paraText3" color={"#101828"}>
                                                    {contact.Name}
                                                </Typography>
                                                <Box display={"flex"} marginTop={"0.25rem"}>
                                                    <MailOutlineIcon fontSize="small" sx={{ color: "brand.main" }} />
                                                    <Typography component={"p"} variant="paraText6" color={"#475467"} marginLeft={"0.25rem"}>
                                                        {contact.Email}
                                                    </Typography>
                                                </Box>
                                                <Box display={"flex"} marginTop={"0.25rem"}>
                                                    <PhoneOutlinedIcon fontSize="small" sx={{ color: "brand.main" }} />
                                                    <Typography component={"p"} variant="paraText6" color={"#475467"} marginLeft={"0.25rem"}>
                                                        {contact.Phone}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                </>
            )}

            {leadData?.length > 0 && (
                <>
                    <Divider sx={{ margin: "1.5rem -24px" }} />
                    <Grid container spacing={2}>
                        {leadData.map((contact) => {
                            return (
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <Typography component={"h5"} variant="paraText5" color={"gray.main"}>
                                            {contact.title}
                                        </Typography>

                                        <Box display={"flex"} alignItems={"start"} marginTop={"0.5rem"}>
                                            <Box
                                                component={"img"}
                                                src={contact.imageURL}
                                                alt=""
                                                borderRadius={"8px"}
                                                height={50}
                                                width={50}
                                                marginRight={"0.8rem"} marginTop={'4px'}></Box>
                                            <Box>
                                                <Typography component={"p"} variant="paraText3" color={"#101828"}>
                                                    {contact.Name}
                                                </Typography>
                                                {!contact.displayOnlyEmail && (
                                                    <Box display={"flex"} marginTop={"0.25rem"}>
                                                        <PhoneOutlinedIcon
                                                            fontSize="small"
                                                            sx={{ color: "brand.main" }}
                                                        />
                                                        <Typography
                                                            component={"p"}
                                                            variant="paraText6"
                                                            color={"#475467"}
                                                            marginLeft={"0.25rem"}>
                                                            {contact.Phone}
                                                        </Typography>
                                                    </Box>
                                                )}
                                                {contact.displayOnlyEmail && (
                                                    <Box display={"flex"} marginTop={"0.25rem"}>
                                                        <MailOutlineIcon
                                                            fontSize="small"
                                                            sx={{ color: "brand.main" }}
                                                        />
                                                        <Typography
                                                            component={"p"}
                                                            variant="paraText6"
                                                            color={"#475467"}
                                                            marginLeft={"0.25rem"}>
                                                            {contact.Email}
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                </>
            )}

            <Divider sx={{ margin: "1.5rem -24px" }} />

            {data?.eventContactNotes && (
                <Card
                    sx={{
                        borderRadius: "10px",
                        border: " 1px solid  #E9E9E9",
                        boxShadow: "none",
                    }}>
                    <CardHeader
                        title="Contact Notes"
                        sx={{
                            padding: "1rem",
                            borderBottom: "1px solid  #E9E9E9",
                        }}
                        titleTypographyProps={{
                            variant: "paraText3",
                            color: "#272F59",
                        }}></CardHeader>
                    <CardContent
                        sx={{
                            padding: "1rem",
                        }}>
                        {/* <div dangerouslySetInnerHTML={{ __html: data.eventContactNotes }} /> */}
                        <RenderContent htmlString={data.eventContactNotes?.replaceAll("\n", "<br>")} />
                    </CardContent>
                </Card>
            )}
        </div>
    );
}

export default EventContacts;
